var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalmart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#0071CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9242 9.04303C12.3457 9.04303 12.7006 8.82281 12.7468 8.53968L13.1647 3.80232C13.1647 3.33321 12.6128 2.94922 11.9242 2.94922C11.2318 2.94922 10.6836 3.33321 10.6836 3.80232L11.1051 8.53968C11.1495 8.82281 11.5026 9.04303 11.9242 9.04303Z",
    fill: "#FCB61A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3611 10.5254C9.56998 10.1553 9.55796 9.74452 9.33244 9.56132L5.43146 6.83085C5.02568 6.59399 4.41831 6.8762 4.07076 7.47392C3.7241 8.07071 3.79435 8.74061 4.19184 8.97285L8.51062 10.977C8.78703 11.0806 9.14845 10.8881 9.3611 10.5217",
    fill: "#FCB61A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4874 10.5216C14.7083 10.888 15.0697 11.0804 15.3387 10.9824L19.6575 8.97268C20.0587 8.73581 20.1188 8.07239 19.7796 7.47559C19.4329 6.87787 18.8219 6.59752 18.417 6.82976L14.5151 9.55744C14.2988 9.74342 14.2831 10.1561 14.492 10.5253",
    fill: "#FCB61A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9242 14.9604C12.3457 14.9604 12.7006 15.1807 12.7468 15.4638L13.1647 20.2012C13.1647 20.6703 12.6128 21.0506 11.9242 21.0506C11.2318 21.0506 10.6836 20.6703 10.6836 20.2012L11.1051 15.4638C11.1495 15.1807 11.5026 14.9604 11.9242 14.9604Z",
    fill: "#FCB61A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4874 13.4824C14.7083 13.115 15.0697 12.9189 15.3387 13.0253L19.6575 15.0313C20.0587 15.2635 20.1188 15.9325 19.7796 16.5302C19.4329 17.1233 18.8219 17.4055 18.417 17.1733L14.5151 14.4419C14.2988 14.2577 14.2831 13.8469 14.492 13.4824",
    fill: "#FCB61A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3611 13.4783C9.56998 13.8475 9.55796 14.2574 9.33244 14.4424L5.43146 17.1692C5.02568 17.4061 4.41831 17.1229 4.07076 16.5298C3.7241 15.933 3.79435 15.2631 4.19184 15.0309L8.51062 13.0249C8.78703 12.9194 9.14845 13.1137 9.3611 13.4783Z",
    fill: "#FCB61A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmart);
export default __webpack_public_path__ + "static/media/walmart.11f9b5d5.svg";
export { ForwardRef as ReactComponent };